import { getOrgDomain } from '../organization';

const getOrgName = () => {
  const currentUrl = window.location.href;
  const parsedUrl = new URL(currentUrl);
  const { pathname } = parsedUrl;
  const pathParts = pathname.split('/');
  const indexOfOrg = pathParts.indexOf('org');

  if (indexOfOrg !== -1 && indexOfOrg < pathParts.length - 1) {
    return pathParts[indexOfOrg + 1];
  }

  return null;
};

const getTenantFromSubdomain = () => {
  const subdomain = getOrgDomain();
  // getOrgDomain returns empty string if no subdomain, so return null for consistency
  return subdomain || null;
};

const orgFlag = () => {
  const org = getOrgName();

  if (org) {
    return '?organization=true';
  }

  return '';
};

export {
  getOrgName, orgFlag, getTenantFromSubdomain
};
